export const DEFAULT_SLIDES_AMOUNT = 1;
